import { useQuery } from "@tanstack/react-query";
import { LayoutList, Users } from "lucide-react";
import { api } from "@/lib/api";
import { AccountSidebar } from "@/components/AccountSidebar";
import { ChatList } from "@/components/ChatList";
import { MessagePane } from "@/components/MessagePane";
import { UnifiedChatList } from "@/components/UnifiedChatList";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { useWorkspace } from "@/store/workspace";
import { cn } from "@/lib/utils";

export function Workspace() {
  const { viewMode, setViewMode, selectedAccountId, selectedChatId } = useWorkspace();

  const { data: accounts = [] } = useQuery({
    queryKey: ["accounts"],
    queryFn: api.listAccounts,
    refetchInterval: 30_000,
  });

  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="flex w-12 shrink-0 flex-col items-center gap-1 border-r border-border bg-card/30 py-3">
        <ModeButton
          active={viewMode === "by-account"}
          onClick={() => setViewMode("by-account")}
          title="По аккаунтам"
        >
          <Users className="h-4 w-4" />
        </ModeButton>
        <ModeButton
          active={viewMode === "all-chats"}
          onClick={() => setViewMode("all-chats")}
          title="Все диалоги"
        >
          <LayoutList className="h-4 w-4" />
        </ModeButton>
      </div>

      {viewMode === "by-account" ? (
        <>
          <AccountSidebar />
          <ChatList />
        </>
      ) : (
        <UnifiedChatList accounts={accounts} />
      )}
      {/* Ключ по чату: падение переписки не уносит весь UI, а переход в другой
          чат пересобирает панель заново — без релоада страницы. */}
      <ErrorBoundary
        key={`${selectedAccountId}:${selectedChatId}`}
        label="Не удалось отрисовать переписку"
      >
        <MessagePane showAccountBadge={viewMode === "all-chats"} accounts={accounts} />
      </ErrorBoundary>
    </div>
  );
}

function ModeButton({
  active,
  onClick,
  title,
  children,
}: {
  active: boolean;
  onClick: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      title={title}
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground",
        active && "bg-accent text-foreground"
      )}
    >
      {children}
    </button>
  );
}
